// extracted by mini-css-extract-plugin
module.exports = {"root":"routePage_root__3nFkO","content":"routePage_content__2rFJ0","tabsContainer":"routePage_tabsContainer__38HXa"};